export class Experience {
  constructor() {
    this.develop = null;
    this.design = null;
    this.sound = null;
  }
}